import { useState } from "react";

export default function DisclaimerModal({
  open,
  text,
  onAccept,
}: {
  open: boolean;
  text: string;
  onAccept: () => Promise<void>;
}) {
  const [checked, setChecked] = useState(false);
  const [sending, setSending] = useState(false);

  if (!open) return null;

  const handleAccept = async () => {
    setSending(true);
    try {
      await onAccept();
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[1000] bg-black/60 flex items-center justify-center p-4">
      <div className="bg-[#161b27] rounded-2xl border border-[#2a3347] max-w-2xl w-full p-6">
        <h2 className="text-sm font-semibold text-slate-100 mb-4">Testversion – Hinweis</h2>
        <div className="max-h-64 overflow-auto bg-[#1e2639] border border-[#2a3347] rounded-xl p-3 text-xs text-slate-400 whitespace-pre-wrap">
          {text}
        </div>

        <label className="flex items-start gap-2 mt-4 text-xs text-slate-400 cursor-pointer">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-0.5 accent-sky-500"
          />
          <span>
            Ich habe den Hinweis gelesen und akzeptiere, dass ich die MVP-Testversion
            von Svevana auf eigenes Risiko nutze.
          </span>
        </label>

        <div className="mt-5 flex justify-end gap-2">
          <button className="text-xs px-3 py-1.5 rounded-full bg-[#1e2639] text-slate-600 cursor-not-allowed" disabled>
            Abbrechen
          </button>
          <button
            className={`text-xs px-3 py-1.5 rounded-full transition-colors ${checked ? "bg-sky-600 text-white hover:bg-sky-500" : "bg-[#1e2639] text-slate-600 cursor-not-allowed"}`}
            disabled={!checked || sending}
            onClick={handleAccept}
          >
            {sending ? "Speichere…" : "Akzeptieren"}
          </button>
        </div>
      </div>
    </div>
  );
}
